import { render, staticRenderFns } from "./dashboard-medecin.html?vue&type=template&id=6ec10120&scoped=true&external"
import script from "./dashboard-medecin.js?vue&type=script&lang=js&external"
export * from "./dashboard-medecin.js?vue&type=script&lang=js&external"
import style0 from "./dashboard-medecin.scss?vue&type=style&index=0&id=6ec10120&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec10120",
  null
  
)

export default component.exports